/* This file is generated by a script. Do not modify. */

export const supportedComponents = [
  'Box',
  'Button',
  'ComparisonTable',
  'FAQ',
  'Heading',
  'Image',
  'Label',
  'Pillar',
  'Stack',
  'SectionIntro',
  'Statistic',
  'Testimonial',
  'Text',
  'Statistic',
  'Timeline',
  'Animate',
  'River',
  'RiverBreakout',
]
